export const buildPreezieScript = document => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = 'https://api.preezie.com/preguide.min.js'
  document.body.appendChild(script)
}

export const removePreezieScript = document => {
  const scripts = document.getElementsByTagName('script')
  for (const script of scripts) {
    if (
      script.getAttribute('src') === 'https://api.preezie.com/preguide.min.js'
    ) {
      document.body.removeChild(script)
    }
  }
}
